import ptCoreClient from 'plant-core-client';
import {
	ACTION_CREATE_ROLE,
	ACTION_DELETE_ROLE,
	ACTION_GET_ALL_ROLES,
	ACTION_UPDATE_ROLE,
	GETTER_ALL_ROLES,
	GETTER_USER_ROLE,
	MUTATION_SET_ALL_ROLES,
	MUTATION_SET_USER_ROLE,
	STATE_ALL_ROLES,
	STATE_USER_ROLE,
	STORE_ROLES_NAME
} from '@/store_constants/roles';

export default {
	name: STORE_ROLES_NAME,
	namespaced: true,
	state: {
		[STATE_ALL_ROLES]: null,
		[STATE_USER_ROLE]: null
	},
	getters: {
		[GETTER_ALL_ROLES](state) {
			return state[STATE_ALL_ROLES];
		},
		[GETTER_USER_ROLE](state) {
			return state[STATE_USER_ROLE];
		}
	},
	mutations: {
		[MUTATION_SET_ALL_ROLES](state, roles) {
			state[STATE_ALL_ROLES] = roles;
		},
		[MUTATION_SET_USER_ROLE](state, role) {
			state[STATE_USER_ROLE] = role;
		}
	},
	actions: {
		[ACTION_GET_ALL_ROLES]({ commit, dispatch }) {
			return ptCoreClient
				.getRoles()
				.then(res => {
					const roles = res;
					commit(MUTATION_SET_ALL_ROLES, roles);
				})
				.catch(error => {
					dispatch('notifications/error', { message: 'An error occurred while trying to get roles' }, { root: true });

					return error;
				});
		},
		[ACTION_CREATE_ROLE]({ commit, dispatch }, { name, description, permissions }) {
			return ptCoreClient
				.createRole(name, description, permissions)
				.then(res => {
					dispatch(ACTION_GET_ALL_ROLES);
					return res;
				})
				.catch(error => {
					dispatch(
						'notifications/error',
						{ message: 'An error occurred while trying to create a new role' },
						{ root: true }
					);

					return error;
				});
		},
		[ACTION_UPDATE_ROLE]({ commit, dispatch }, { id, role }) {
			return ptCoreClient
				.updateRole(id, role)
				.then(res => {
					dispatch(ACTION_GET_ALL_ROLES);
				})
				.catch(error => {
					dispatch('notifications/error', { message: 'An error occurred while trying to update role' }, { root: true });

					return error;
				});
		},
		[ACTION_DELETE_ROLE]({ commit, dispatch }, { id }) {
			return ptCoreClient
				.deleteRole(id)
				.then(res => {
					dispatch(ACTION_GET_ALL_ROLES);
				})
				.catch(error => {
					dispatch('notifications/error', { message: 'An error occurred while trying to delete role' }, { root: true });

					return error;
				});
		}
	}
};
